import { render, staticRenderFns } from "./defaultSms.vue?vue&type=template&id=15dcabbd&scoped=true"
import script from "./defaultSms.vue?vue&type=script&lang=js"
export * from "./defaultSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dcabbd",
  null
  
)

export default component.exports